// NodeSubtitle.js

export const SUBTITLE_FIELD_TYPE = 'subtitle';
export const LEGACY_SUBTITLE_FIELD_TYPE = 'description';
export const DEFAULT_SUBTITLE_FIELD_KEY = 'subtitle';
export const LEGACY_SUBTITLE_FIELD_KEY = 'description';

export function isSubtitleFieldType(fieldType) {
  const normalized = String(fieldType || '').trim().toLowerCase();
  return normalized === SUBTITLE_FIELD_TYPE || normalized === LEGACY_SUBTITLE_FIELD_TYPE;
}

export function isSubtitleFieldKey(fieldKey, fieldType) {
  const normalizedKey = String(fieldKey || '').trim().toLowerCase();
  if (
    normalizedKey === DEFAULT_SUBTITLE_FIELD_KEY
    || normalizedKey === LEGACY_SUBTITLE_FIELD_KEY
  ) {
    return true;
  }

  return isSubtitleFieldType(fieldType);
}

export function getNodeSubtitle(node) {
  if (!node) return '';

  if (Object.prototype.hasOwnProperty.call(node, 'subtitle')) {
    return String(node.subtitle || '');
  }

  return String(node.description || '');
}

export function normalizeNodeSubtitleValue(value) {
  return String(value || '').trim();
}

export function buildNodeSubtitlePatch(value) {
  return { subtitle: normalizeNodeSubtitleValue(value) };
}

export function getViewIncludeSubtitle(view) {
  if (!view) return false;
  if (Object.prototype.hasOwnProperty.call(view, 'includeSubtitle')) {
    return Boolean(view.includeSubtitle);
  }
  return Boolean(view.includeDescription);
}

export function resolveSubtitleFieldKey(fieldKey, { includeSubtitle = false } = {}) {
  const normalized = String(fieldKey || '').trim();
  if (normalized) return normalized;
  return includeSubtitle ? DEFAULT_SUBTITLE_FIELD_KEY : '';
}

export function viewPropertiesIncludeSubtitle(properties) {
  const keys = Array.isArray(properties) ? properties : [];
  return keys.includes(DEFAULT_SUBTITLE_FIELD_KEY) || keys.includes(LEGACY_SUBTITLE_FIELD_KEY);
}
